<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>For LYNNE and SONNY</i></span></p>
<p class="ded1"><span>… <i>who both see</i> and <i>observe</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?599eb339